import{n as r}from"./chunk-P7WGFKOM.js";import{m as e}from"./chunk-HBP5N4FR.js";e();r();var t=typeof window!="undefined"?window:{},w=()=>t.ReactNativeWebView?"reactNative":t.webkit?"ios":"web";export{w as a};
//# sourceMappingURL=chunk-NWZRIDQH.js.map
